import { useState } from "react";

const useApi = (apiFunc) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const request = async (...args) => {
    setLoading(true);
    const response = await apiFunc(...args);
    setLoading(false);

    setError(response?.status > 399); // 400 & 500 are error
    setData(response.data);
    return response;
  };

  return { request, data, error, loading };
};

export default useApi;
